<template>
  <div class="wp">
    <div v-if="loaded" class="area img-wrap" ref="area">
      <div
        class="ts-wrap loaded"
        :style="{
          transform: `scale(${zoom})`,
          height: `${height}px`,
          flexBasis: `${height}px`,
          marginLeft: `${leftMargin / 2}px`,
        }"
      >
        <img :src="value" class="view" />
        <tag
          v-for="(tag, idx) in tags"
          :key="`tag${idx}`"
          :id="idx"
          :x="tag.x"
          :y="tag.y"
          :w="tag.w"
          :h="tag.h"
          :zoomRatio="zoom"
          :clear="tagList[idx]"
          @clear="clearTag"
          @reset="resetTag"
        ></tag>
      </div>
    </div>
    <div class="clear-sets">
      <button @click="setAll" @touchstart="setAll" :disabled="allClear">
        付せんをはずす
      </button>
      <button @click="clearAll" @touchstart="clearAll" :disabled="!clear">
        付せんをつける
      </button>
    </div>
    <!--
      <div
        style="
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(255, 255, 255, 0.8);
        "
      >
        {{ height }} {{ zoom }}
      </div>
    -->
    <img
      v-show="!imgSetted"
      :src="value"
      class="get-size"
      @load="imgLoaded"
      ref="img"
    />
  </div>
</template>

<script>
/* eslint-disable no-console */
import tag from "./tag.vue";

export default {
  name: "tagArea",
  props: {
    value: String,
    tags: Array,
    hasOption: Boolean
  },
  components: {
    tag
  },
  data() {
    return {
      zoom: 1,
      tagList: [],
      leftMargin: 0,
      loaded: false,
      imgSetted: false,
      winWidth: false,
      winHeight: false,
      height: 0,
      wrapHeight: 0
    };
  },
  mounted() {
    this.tags.forEach(() => {
      this.tagList.push(false);
    });
    window.addEventListener("resize", this.init);
    // this.init();
  },
  watch: {
    sent(nv) {
      if (!nv) {
        return;
      }
      this.setAll();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.init);
  },
  computed: {
    clear() {
      return this.tagList.filter(e => e === true).length;
    },
    allClear() {
      return this.clear === this.tagList.length;
    },
    sent() {
      return this.$store.getters.sent || this.$store.state.mode === "end";
    }
  },
  methods: {
    clearTag(idx) {
      console.log(idx);
      this.$set(this.tagList, idx, true);
    },
    resetTag(idx) {
      console.log(idx);
      this.$set(this.tagList, idx, false);
    },
    clearAll() {
      console.log("clearAll");
      this.tags.forEach((e, idx) => {
        this.$set(this.tagList, idx, false);
      });
    },
    setAll() {
      this.tags.forEach((e, idx) => {
        this.$set(this.tagList, idx, true);
      });
    },
    start(e) {
      console.log(e);
      e.preventDefault();
    },
    imgLoaded() {
      console.log("img loaded");
      this.loaded = true;
      this.$nextTick(() => {
        this.init();
      });
    },
    init() {
      console.log("tagArea init");
      if (
        this.loaded &&
        this.winWidth === window.innerWidth &&
        this.winHeight === window.innerHeight
      ) {
        // ウインドウ横幅が変わっていないため処理をキャンセル。
        return;
      }

      this.winWidth = window.innerWidth;
      this.winHeight = window.innerHeight;

      this.imgSetted = false;
      this.$nextTick(() => {
        let optionBlockSize = this.hasOption ? 72 : 0;

        let clearBlockSize = 72;

        this.zoom =
          Math.floor(
            (this.$refs.area.clientWidth / this.$refs.img.width) * 1000
          ) / 1000;
        this.height = Math.max(
          Math.ceil(this.$refs.img.height * this.zoom),
          Math.floor(this.$refs.img.height * this.zoom)
        );
        let wrapHeight = this.height + optionBlockSize + clearBlockSize;

        if (wrapHeight > window.innerHeight - 200) {
          this.zoom =
            Math.ceil(
              (this.$refs.area.clientWidth / this.$refs.img.width) * 1000
            ) / 1000;

          this.height = Math.max(
            Math.ceil(this.$refs.img.height * this.zoom),
            Math.floor(this.$refs.img.height * this.zoom)
          );
          wrapHeight = this.height + optionBlockSize + clearBlockSize;
        }

        this.$nextTick(() => {
          const areaHeight = Math.max(
            window.innerHeight,
            document.querySelector(".input-container").clientHeight
          );

          if (
            window.innerWidth > window.innerHeight &&
            wrapHeight >= areaHeight - 170
          ) {
            this.$emit("blockSize", areaHeight - 170 + "px");
          } else {
            if (
              wrapHeight >=
              window.areaHeight - 170 - (optionBlockSize + clearBlockSize)
            ) {
              this.$emit(
                "blockSize",
                areaHeight - 170 - (optionBlockSize + clearBlockSize) + "px"
              );
            } else {
              this.$emit("blockSize", wrapHeight + "px");
            }
          }

          if (this.sent) {
            this.$nextTick(() => {
              this.imgSetted = true;
              console.log(this.imgSetted);
              this.setAll();
            });
          }

          this.$nextTick(() => {
            this.imgSetted = true;
            wrapHeight = this.height + optionBlockSize + clearBlockSize;

            if (this.height === this.$refs.area.clientHeight) {
              this.$emit("blockSize", wrapHeight + "px");
            }

            this.$nextTick(() => {
              this.leftMargin =
                this.$refs.area.clientWidth - this.$refs.img.width * this.zoom;
            });
          });
        });
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wp {
  overflow: hidden;
  flex-direction: column;
}

button {
  width: 150px;
  font-size: medium;
  margin: 5px;
  background: #3553a7;
  color: #fff;
  border: none;
  border-radius: 0.3rem;
}

button:disabled {
  opacity: 0.3;
}

.clear-sets {
  width: 100%;
  text-align: right;

  flex: 0 0 72px;
}

.ts-wrap.presentation {
  display: flex;
  flex-flow: column;

  width: 100%;
  height: 100%;

  overflow: hidden;
}

.ts-wrap.loaded {
  display: block;
  position: relative;
  width: 0px;

  margin: auto 0;
  transform-origin: 0 0;
}

.area {
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  justify-content: flex-start;
  align-items: center;

  overflow-x: hidden;
  overflow-y: auto;

  margin: auto 0;
}

.area img {
  position: absolute;
  top: 0;
  left: 0;

  pointer-events: none;
  margin: auto 0;
}

.get-size {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
